import {
    FETCH_START,
    FETCH_ERROR,
    FETCH_SUCCESS,
    DB_LIST_ORGANISATIONS,
    DB_GET_ORGANISATION,
  } from "constants/ActionTypes"
  
  
  import setupAxiosInterceptors from "appRedux/actions/setupAxiosInterceptors";
  
  import axiosDB from 'util/ApiDB'
  
  export const ActionOrganisationGet = (id) => {
    return (dispatch, getState) => {
      dispatch({type: FETCH_START})
  
      const request = setupAxiosInterceptors(axiosDB, dispatch, getState);
  
      request.get('organisations/' + id).then(({data}) => {
        dispatch({type: DB_GET_ORGANISATION, payload: {
          organisation: data.response.organisation
        }})
        dispatch({ type: FETCH_SUCCESS })
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
        console.log("Error****:", error.message);
      });
    }
  }
  
  export const ActionOrganisationsList = () => {
    return (dispatch, getState) => {
      dispatch({type: FETCH_START})
  
      const request = setupAxiosInterceptors(axiosDB, dispatch, getState);
  
      request.get('organisations').then(({data}) => {
        const organisations = data.response.organisations
  
        const stateUpdateOrganisations = (organisations, dispatch) => new Promise((resolve, reject) => {
          dispatch({type: DB_LIST_ORGANISATIONS, payload: {organisations: organisations}})
          resolve()
        })
  
        stateUpdateOrganisations(organisations, dispatch).then(()=>{
          dispatch({ type: FETCH_SUCCESS });
        })
  
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
        console.log("Error****:", error.message);
      })
    }
  }
  
  export const ActionOrganisationAdd = (formData) => {
    return (dispatch, getState) => {
      dispatch({type: FETCH_START})
  
      const request = setupAxiosInterceptors(axiosDB, dispatch, getState);
  
      request.post('organisations/store', {
        formData: formData
      }).then(({data}) => {
        dispatch(ActionOrganisationsList());
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
        console.log("Error****:", error.message);
      });
    }
  }
  
  export const ActionOrganisationUpdate = (formData) => {
    return (dispatch, getState) => {
      dispatch({type: FETCH_START})
  
      const {db_organisation} = getState().system.organisations;
  
      const request = setupAxiosInterceptors(axiosDB, dispatch, getState);
  
      request.post('organisations/' + db_organisation.id + '/update', {
        formData: formData
      }).then(({data}) => {      
        dispatch(ActionOrganisationsList());
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
        console.log("Error****:", error.message);
      });
    }
  }
  
  export const ActionOrganisationDelete = (id) => {
    return (dispatch, getState) => {
      dispatch({type: FETCH_START})
  
      const request = setupAxiosInterceptors(axiosDB, dispatch, getState);
  
      request.post('organisations/' + id + '/delete', {}).then(({data}) => {
        dispatch(ActionOrganisationsList());
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
        console.log("Error****:", error.message);
      });
    }
  }
  
  export const ActionOrganisationReset = () => {
    return (dispatch) => {
      dispatch({type: DB_GET_ORGANISATION, payload: {organisation: null}})
    }
  }
  
  export const ActionListClientsByOrganisation = (pid, organisation) => {
    return (dispatch, getState) => {
      dispatch({type: FETCH_START})
  
      const request = setupAxiosInterceptors(axiosDB, dispatch, getState);
  
      request.post('projects/' + pid + '/clients-by-organisation', {
        organisation: organisation
      }).then(({data}) => {
        dispatch({ type: FETCH_SUCCESS });
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
        console.log("Error****:", error.message);
      });
    }
  }
  
  export const ActionSearchClientsByOrganisation = (pid, organisation, search_term) => {
    return (dispatch, getState) => {
      dispatch({type: FETCH_START})
  
      const request = setupAxiosInterceptors(axiosDB, dispatch, getState);
  
      request.post('projects/' + pid + '/search-clients-by-organisation', {
        organisation: organisation,
        search_term: search_term
      }).then(({data}) => {
        dispatch({ type: FETCH_SUCCESS });
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
        console.log("Error****:", error.message);
      });
    }
  }

  export const ActionSaveHeader = (image, oid, color, left, top, bottom) => {
    return (dispatch, getState) => {
      dispatch({type: FETCH_START})
      const request = setupAxiosInterceptors(axiosDB, dispatch, getState);
  
      request.post('organisations/' + oid + '/header',{
        logo: image,
        color: color,
        left: left,
        top: top,
        bottom: bottom,
      }).then(({data}) => {
        dispatch({ type: FETCH_SUCCESS })
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
        console.log("Error****:", error.message);
      }); 
    }
  }

  export const ActionGetOrganisationByName = (name) => {
    return (dispatch, getState) => {
      dispatch({type: FETCH_START})
  
      const request = setupAxiosInterceptors(axiosDB, dispatch, getState);
  
      request.post('organisations/getbyname',{
        name: name,
      }).then(({data}) => {
        dispatch({type: DB_GET_ORGANISATION, payload: {
          organisation: data.response.organisation
        }})
        dispatch({ type: FETCH_SUCCESS })
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
        console.log("Error****:", error.message);
      }); 
    }
  }